import React from "react";
import silhouette from "../../../images/headshot-silhouette-30.png";

interface ProfileImageProps {
  profile_pic_url: string | null;
}

const ProfileImage: React.FC<ProfileImageProps> = ({ profile_pic_url }) => {
  return (
    <div className="dashboard-profile-banner-circle-container">
      <div className="dashboard-profile-banner-outer-circle">
        <div className="dashboard-profile-banner-inner-circle">
          <img
            src={profile_pic_url || silhouette}
            alt="Profile"
            className="dashboard-profile-banner-profile-picture"
            onError={(e) => {
              e.currentTarget.src = silhouette;
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ProfileImage;
